import classes from "./TalentProfile.module.css";
import Button, { YellowButton } from "../../../components/UI/Button/button";
import { useLocation, useNavigate, useParams } from "react-router";
import { useContext, useEffect, useRef, useState } from "react";
import {
  describeMatchCost,
  quoteErrorText,
  quoteFromResponse,
  errorHandler,
  isPlanLimitError,
  planLimitHandler,
  toastSuccess,
} from "../../../utils";
import { talentProfile } from "../../../services/talentCalls";
import {
  clientAddShortlistTalent,
  clientGetActiveSubscriptions,
  clientGetAnonymizedCV,
  clientGetSearchTalent,
  clientRemoveShortlistTalent,
  clientViewShortlist,
  getAllClientJobs,
  getClientCurrentSubscription,
  matchTalent,
  previewMatchCost,
} from "../../../services/clientCalls";
import { Link, useSearchParams } from "react-router-dom";
import FullScreenLoader from "../../../components/Loaders/FullScreen/loader";
import ErrorModal from "../../../layout/ErrorModal/ErrorModal";
import confusedStan from "../../../assets/illustrations/no-sub-stan.png";
import ToastErrorModal from "../../../components/errorModal/errorModal";
import PopupModal from "../../../components/CancelMatch/Popup/popup";
import { CustomCheckbox } from "../../../components/UI/CheckBox/checkbox";
import { UserContext } from "../../../context";
import Breadcrumb from "../../../components/UI/Breadcrumb/Breadcrumb";
import styles from "./TalentProfile.module.css";
import { IconArrowLeft, IconShieldExclamation } from "@tabler/icons-react";
import TalentHero from "./components/TalentHero";
import SummaryCard from "./components/SummaryCard";
import AiSummaryCard from "./components/AiSummaryCard";
import ExperienceCard from "./components/ExperienceCard";
import WorkPrioritiesCard from "./components/WorkPrioritiesCard";
import ResumeCard from "./components/ResumeCard";
import OverviewCard from "./components/OverviewCard";
import EducationCard from "./components/EducationCard";
import SkillsCard from "./components/SkillsCard";
import ScoreComparisonCard, {
  mapToScoreComparisonData,
} from "./components/ScoreComparison";
import MatchRatingCard from "./components/MatchRatingCard";
import CustomModal from "../../../components/Modal/CustomModal";
import ModalShell from "../../../components/Support/ModalShell";
import CandidateFitCard, {
  mapToCandidateFitData,
} from "./components/CandidateFitCard";
import AiInsightsCard, {
  mapToAiInsightsData,
} from "./components/AiInsightsCard";

const TalentProfile = ({ type }) => {
  const { role } = useContext(UserContext);

  const [data, setData] = useState({});
  let navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resumeData, setResumeData] = useState(null);
  const [isAdvancedSearch, setIsAdvancedSearch] = useState(false);
  const [shortlisted, setShortlisted] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const [param] = useSearchParams();
  const [trialMode, setTrialMode] = useState(false);
  const [, setIsModalOpen] = useState(false);
  const [createJobModal, setCreateJobModal] = useState(false);
  const [notSubscribed, setNotSubscribed] = useState(false);
  const [notSubscribedModal, setNotSubscribedModal] = useState(false);
  const { talent } = location?.state || {};
  const [matchQuote, setMatchQuote] = useState(null);
  const [quoteNote, setQuoteNote] = useState("");
  const [quoteLoading, setQuoteLoading] = useState(false);
  const quoteRequest = useRef(0);
  const [searchLoading, setSearchLoading] = useState(false);
  const [jobs, setJobs] = useState(null);
  const [disclaimerModal, setDisclaimerModal] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [shortlistLoading, setShortlistLoading] = useState(false);
  const [isShortlisted, setIsShortlisted] = useState(false);

  const fetchJobs = async (page) => {
    try {
      setLoad(true);
      const res = await getAllClientJobs(page);
      if (res?.data.data.records) {
        setJobs(res?.data.data.records);
      }

      setLoad(false);
    } catch (error) {
      setLoad(false);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const handleCheckSubscriptions = async () => {
    setLoading(true);
    try {
      const res = await getClientCurrentSubscription();
      if (
        !res?.data?.data?.data?.planName ||
        !res?.data?.data?.data?.isActive
      ) {
        setNotSubscribed(true);
      }
    } catch (error) {
      if (error?.response?.data?.success === false) {
        setNotSubscribed(true);
      } else {
        error?.response?.data
          ? errorHandler(error?.response?.data?.errors, "Error", () =>
              navigate(-1),
            )
          : errorHandler(
              "Network error: Something went wrong, Please check your internet connection and try again.",
              "Error",
            );
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleCheckSubscriptions();
    fetchJobs();
  }, []);

  useEffect(() => {
    if (param.get("advanced-search") === "true") {
      setIsAdvancedSearch(true);
    } else {
      setIsAdvancedSearch(false);
    }
  }, [param]);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const res = await talentProfile();
      if (res?.data?.data?.talent) {
        setData(res?.data?.data?.talent);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        if (
          error.response.data.errors.includes("You do not have an active quota")
        ) {
          setIsModalOpen(true);
        } else {
          errorHandler(error.response.data.errors, "Error");
        }
      } else {
        errorHandler(
          "Network error: Something went wrong, Please check your internet connection and try again.",
          "Error",
        );
      }
    } finally {
      setLoading(false);
    }
  };
  const handleViewShortlist = async () => {
    setLoading(true);
    try {
      const res = await clientViewShortlist(id);
      if (res?.data?.data?.shortlistedTalent) {
        setData(res?.data?.data?.shortlistedTalent);
        setShortlisted(true);
      }
    } catch (error) {
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setLoading(false);
    }
  };

  const fetchAdvancedSearchTalent = async () => {
    setSearchLoading(true);
    try {
      const res = await clientGetSearchTalent(id);
      if (res?.data?.data?.talentDetails) {
        setData(res?.data?.data?.talentDetails);
        setTrialMode(false);
      }
      if (res?.data?.data?.shortlisted === true) {
        setIsShortlisted(true);
      } else {
        setIsShortlisted(false);
      }
    } catch (error) {
      if (error?.response?.status === 403) {
        if (error?.response?.data?.errors) {
          errorHandler(error?.response?.data?.errors, "Error");
        }
        setTrialMode(true);
        navigate(-1);
        return;
      }
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setSearchLoading(false);
    }
  };

  const handleMatch = async () => {
    // if (job.applicantTalentIds?.includes(id)) {
    //   errorHandler("You have already matched this talent", "Error");
    //   return;
    // }
    if (!agreed) {
      const requestId = ++quoteRequest.current;
      setMatchQuote(null);
      setQuoteNote("");
      setQuoteLoading(true);
      setDisclaimerModal(true);
      previewMatchCost(id)
        .then((res) => {
          if (quoteRequest.current !== requestId) return;
          const quote = quoteFromResponse(res);
          if (quote) setMatchQuote(quote);
          else setQuoteNote("We couldn't load the price for this match.");
        })
        .catch((error) => {
          if (quoteRequest.current !== requestId) return;
          setMatchQuote(null);
          setQuoteNote(quoteErrorText(error));
        })
        .finally(() => {
          if (quoteRequest.current === requestId) setQuoteLoading(false);
        });
      return;
    }
    try {
      setLoad(true);
      const res = await matchTalent(id);
      const data = res?.data?.data;
      if (res?.data?.success && data) {
        toastSuccess("Match Successful", () =>
          navigate("/talent?tab=matches&view=list", { state: data }),
        );

        setTimeout(() => {
          navigate("/talent?tab=matches&view=list", { state: data });
        }, 2000);
      }

      setLoad(false);
    } catch (error) {
      setLoad(false);
      if (isPlanLimitError(error)) return planLimitHandler(error, navigate);
      error.response?.data
        ? errorHandler(error.response.data.errors, "Error", () => navigate(-1))
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const handleShortlist = async (id) => {
    try {
      setShortlistLoading(true);
      const res = await clientAddShortlistTalent(id);
      if (res?.data?.success) {
        toastSuccess("Talent added to shortlist");
      }
    } catch (error) {
      if (isPlanLimitError(error)) return planLimitHandler(error, navigate);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setShortlistLoading(false);
    }
  };

  const handleRemoveShortlist = async (id) => {
    try {
      setShortlistLoading(true);
      const res = await clientRemoveShortlistTalent(id);
      if (res?.data?.success) {
        toastSuccess("Talent removed from shortlist");
      }
    } catch (error) {
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setShortlistLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (talent) {
      // Paint instantly from nav state; still refreshed below for type "client"
      // so the reviewer never gets stuck on a stale applicants-list snapshot.
      setData(talent);
    }
    if (param.get("isShortlist") === "true") {
      handleViewShortlist();
    } else if (type === "talent") {
      if (!talent) fetchProfile();
    } else if (type === "client") {
      fetchAdvancedSearchTalent();
    }
  }, []);

  const handleViewResume = async () => {
    try {
      if (!id) return;
      const res = await clientGetAnonymizedCV(data?._id);
      if (res?.data) {
        setResumeData(res?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (data?._id) {
      handleViewResume();
    }
  }, [data]);

  const handleDownloadCV = () => {
    if (!resumeData) return;

    const url = window.URL.createObjectURL(new Blob([resumeData]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "resume.pdf");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (notSubscribed) {
      setData({});
      setNotSubscribedModal(true);
    }
  }, [notSubscribed]);

  const handleShowCreateJobModal = () => {
    if (!agreed) {
      quoteRequest.current += 1;
      setMatchQuote(null);
      setQuoteLoading(false);
      setQuoteNote("You'll see this match's price after you choose a role.");
      setDisclaimerModal(true);
      return;
    }
    setCreateJobModal(true);
  };

  const handleDisclaimerModalClose = () => {
    setDisclaimerModal(false);
    if (isAdvancedSearch) {
      handleShowCreateJobModal();
    } else {
      handleMatch();
    }
  };

  const priceLine = quoteLoading
    ? "Checking what this match costs…"
    : describeMatchCost(matchQuote) || quoteNote;

  return (
    <div>
      {(loading || searchLoading) && <FullScreenLoader />}

      <Breadcrumb
        crumbs={[
          { label: "Dashboard", href: "/client-activity-summary" },
          { label: "Talents", href: "/talents" },
          // { label: talent?.role },
        ]}
        title="Talent Profile"
        actions={
          // Hidden on mobile via .backHeaderWrap — the hero renders its own
          // "Back to Talents" button on small screens instead (see TalentHero.jsx).
          <div className={styles.backHeaderWrap}>
            <Button
              as={Link}
              to="/talent"
              variant="outline"
              leftIcon={<IconArrowLeft size={15} />}
            >
              Back to Talents
            </Button>
          </div>
        }
      />

      {/* Hero */}
      <TalentHero
        talent={data}
        handleRemoveShortlist={handleRemoveShortlist}
        handleShortlist={handleShortlist}
        shortlistLoading={shortlistLoading}
        isShortlisted={isShortlisted}
        hidden={data?.hidePsychometricResult}
      />

      <div className={styles.grid}>
        <div className={styles.main}>
          <SummaryCard summary={data?.summary} />
          <AiSummaryCard
            data={data}
            psychometricTestResult={data?.psychometricTestResult}
            hidden={data?.hidePsychometricResult}
          />
          <ExperienceCard experiences={data?.workHistoryExperience} />
          <WorkPrioritiesCard priorities={data?.specificPriorities} />
          {resumeData && <ResumeCard talent={data} />}
        </div>

        <div className={styles.side}>
          <OverviewCard talent={data} hidden={data?.hidePsychometricResult} />
          <EducationCard talent={data} />
          <SkillsCard
            primarySkills={data?.primarySkills}
            secondarySkills={data?.secondarySkills}
          />
          <CandidateFitCard {...mapToCandidateFitData(data)} />
          <AiInsightsCard
            items={mapToAiInsightsData(data)}
            onMatchClick={
              isAdvancedSearch ? handleShowCreateJobModal : handleMatch
            }
            shortlisted={shortlisted}
            onMatchWithTalent={() => setCreateJobModal(true)}
            disabled={load || notSubscribed || (trialMode && isAdvancedSearch)}
          />
        </div>
      </div>

      {notSubscribedModal && (
        <CustomModal
          state="failed"
          title="Subscription Required"
          description=" Sorry, this page will be made available once you’re on a payment
            plan."
          primaryLabel="Subscribe"
          secondaryLabel="Contact Support"
          onClose={() => {
            setNotSubscribedModal(false);
            navigate("/subscription-payment");
          }}
          onPrimaryAction={() => {
            setNotSubscribedModal(false);
            navigate("/subscription-payment");
          }}
        />
      )}

      <ModalShell
        open={createJobModal}
        onClose={() => {
          setCreateJobModal(false);
          setDisclaimerModal(false);
        }}
        icon={IconShieldExclamation}
        color="orange"
        title="Create Job"
        subtitle=""
      >
        <div className="flex flex-col gap-2 mb-8 items-center justify-center text-[var(--text-secondary)]">
          <h6 className="text-sm font-bold text-[var(--text-navy)]">
            You will need to create a job first
          </h6>
          <p className="text-center">
            Or would you like to map the Talent to a <br /> published job?
          </p>
        </div>
        <div className="flex gap-6 justify-center mx-auto mb-6">
          <Button
            variant="outline"
            onClick={() => {
              navigate(`/add-new-job/job?talentId=${data?._id}`);
              setCreateJobModal(false);
              setDisclaimerModal(false);
            }}
            className="w-[120px]"
          >
            Create Job
          </Button>
          {jobs?.length > 0 && (
            <Button
              onClick={() => {
                navigate(`/client-jobs?talentId=${data?._id}`);
                setIsModalOpen(false);
              }}
              className="w-[120px]"
            >
              Match to Job
            </Button>
          )}
        </div>
      </ModalShell>

      <ModalShell
        open={disclaimerModal}
        onClose={() => setDisclaimerModal(false)}
        icon={IconShieldExclamation}
        color="orange"
        title="Disclaimer"
        subtitle=""
        footer={
          <>
            <Button onClick={handleDisclaimerModalClose} disabled={!agreed || quoteLoading}>
              Proceed
            </Button>
          </>
        }
      >
        {priceLine && (
          <p className="text-sm mb-6 !text-left !mt-0 text-[var(--text-primary)]">
            {priceLine}
          </p>
        )}
        <div className="flex mb-8">
          <CustomCheckbox
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <p className="text-xs pl-6 !text-left !mt-0 text-[var(--text-secondary)]">
            Awasource AI Insights are provided for informational and
            decision-support purposes. Employers, recruiters, and other third
            parties should consider these insights alongside independent
            evaluation and verification of relevant candidate information and
            not rely on them as the sole basis for any employment-related
            decisions, including hiring, promotion, compensation, or
            termination.
            <br /> <br />
            Decisions should be informed with human judgment as well. Awasource
            disclaims liability for any outcomes resulting from the use of AI
            Insights in employment or workforce decisions, to the fullest extent
            permitted under applicable law, including the Nigeria Data
            Protection Act 2023.
          </p>
        </div>
      </ModalShell>
    </div>
  );
};

export default TalentProfile;
